module.exports = __webpack_public_path__ + "lp/img/device_error_exclamation.421496d5.svg";